module.exports = __webpack_public_path__ + "assets/images/loading_icon.gif?v=900cdddf";